import { Router } from '@angular/router';
import { PageNotFoundData } from '@shared/interfaces';
import { AppRoutes } from './app-routes';

export function computeTextForOrderNotFound(): PageNotFoundData {
    return {
        content: 'order.setup.orderNotFound',
        previousLink: AppRoutes.routes().ORDERS_LIST,
        previousPageTitle: 'Orders',
    };
}

export function displayOrderNotFoundPage(router: Router): void {
    const navigationData: PageNotFoundData = computeTextForOrderNotFound();
    router.navigateByUrl(AppRoutes.routes().NOT_FOUND, { state: navigationData });
}
